var generic = generic || {};
var site = site || {};

(function ($) {
  site.emailSignupTout = {
    templateContainer: $(),
    initEmailSignup: function () {
      var $emailContainerNodes = this.templateContainer;

      if (!$emailContainerNodes.length) {
        return null;
      }

      $emailContainerNodes.each(function () {
        var $emailContainerNode = $(this);
        var $emailForm = $emailContainerNode.is('form') ? $emailContainerNode : $('form', $emailContainerNode);
        var $emailError = $('.email-signup__error', $emailContainerNode);
        var $emailSuccess = $('.thank_you_text', $emailContainerNode);
        var $emailInput = $('input[name="PC_EMAIL_ADDRESS"]', $emailContainerNode);

        $emailForm.once('email-signup__form').submit(function (submitEvt) {
          submitEvt.preventDefault();
          $emailError.addClass('hidden');
          $emailInput.removeClass('error');

          // Transform string into array of form elements
          var params = {};

          $.each($emailForm.serializeArray(), function (index, kv) {
            params[kv.name] = kv.value.replace('undefined', '').replace('%40', '@');
          });

          // Send the data via a json rpc call
          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: [params],
            onSuccess: function (jsonRpcResponse) {
              if (site.client.isMobile) {
                $('body, html').animate({ scrollTop: 0 }, 400);
              }
              $emailSuccess.removeClass('hidden');
              $emailForm.addClass('hidden');
              $('.signup-tout-wrapper .subtitle').addClass('hidden');
            },
            onFailure: function (jsonRpcResponse) {
              $emailError.removeClass('hidden');
              $emailInput.addClass('error');
            }
          });
        });
      });
    }
  };

  Drupal.behaviors.emailSignupTout = {
    attach: function (context, settings) {
      site.emailSignupTout.templateContainer = $('.signup-tout-wrapper', context);
      site.emailSignupTout.initEmailSignup();
    }
  };
})(jQuery);
